import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import Box from "@material-ui/core/Box";
import Footer from "@components/Main/Shared/Footer";
import Header from "@components/Main/Shared/Header";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import useConstants from "@hooks/useConstants";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import SchoolIcon from "@material-ui/icons/School";
import StarIcon from "@material-ui/icons/Star";
import Link from "@material-ui/core/Link";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Divider from "@material-ui/core/Divider";

const { BRAND_NAME, SITE_NAME } = process.env;

const AboutPerson = () => {
	const classes = useStyles("Terms");

	const { clientName, proName, h1, serviceType, p1, p2, p3, p4, bizType, pic } =
		useConstants("BackgroundViewModel");

	return (
		<React.Fragment>
			<Header />

			<Box pl={2} pr={2} mt={6} mb={20}>
				<Container maxWidth="lg">
					<Box mb={10}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							style={{ fontSize: 14, fontWeight: 700 }}
						>
							<Link color="primary" href="/about">
								TEAM
							</Link>
							<div>MALCOLM MCKINSEY</div>
						</Breadcrumbs>
					</Box>
					<Box
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexDirection="column"
						mb={16}
					>
						<Avatar
							variant="rounded"
							src="//static.tutors.com/profile-pro/malcolm_m.jpg"
							alt={"Malcolm McKinsey, M.Ed."}
							style={{ width: 240, height: 240 }}
						/>
						<Box mt={6} mb={2} fontSize={{ xs: 28, sm: 40 }} fontWeight={700}>
							Malcolm McKinsey, M.Ed.
						</Box>
						<Box letterSpacing={2} fontSize={14} fontWeight={700}>
							CONTENT & CURRICULUM WRITER
						</Box>
					</Box>

					<Grid container spacing={10} direction="row-reverse">
						<Grid item xs={12} sm={5} md={4}>
							<Box bgcolor="grey.100" borderRadius={8} p={6}>
								<Box display="flex" alignItems="center" mb={6}>
									<StarIcon color="primary" fontSize="large" />
									<Box pl={4} letterSpacing={2} fontSize={12} fontWeight={700}>
										EXPERTISE
									</Box>
								</Box>
								<ul>
									<li>Mathematics</li>
									<li>Science</li>
									<li>Language arts</li>
									<li>Social studies</li>
									<li>Reading</li>
								</ul>
								<Box pt={6} pb={6}>
									<Divider light />
								</Box>
								<Box display="flex" alignItems="center" mb={6}>
									<SchoolIcon color="primary" fontSize="large" />
									<Box pl={4} letterSpacing={2} fontSize={12} fontWeight={700}>
										EDUCATION
									</Box>
								</Box>
								<ul>
									<li>BFA and MA in education</li>
								</ul>
							</Box>
						</Grid>
						<Grid item xs={12} sm={7} md={8}>
							<Box pr={{ xs: 0, sm: 6 }}>
								<Box mb={6}>
									<Box mb={4} fontWeight={700} fontSize={{ xs: 20, sm: 30 }}>
										Experience
									</Box>

									<Box lineHeight={1.7} color="#515260">
										<p>
											Malcolm holds a BFA and MA in education and has been a
											public school teacher for 27 years. He teaches 4th to
											6th-grade students and also teaches adults to read and to
											earn their GED. He has taught reading, language arts,
											social studies, science, and mathematics.
										</p>
									</Box>
								</Box>
								<Box mb={6}>
									<Box mb={4} fontWeight={700} fontSize={{ xs: 20, sm: 30 }}>
										Highlights
									</Box>

									<Box lineHeight={1.7} color="#515260">
										<p>
											Malcolm has received extensive training in science,
											engineering, and mathematics education from NASA,
											participating in teacher workshops for more than 20 years
											and serving as a teaching coach for a teacher workshop at
											Goddard Space Flight Center.
										</p>
									</Box>
								</Box>
								<Box mb={6}>
									<Box mb={4} fontWeight={700} fontSize={{ xs: 20, sm: 30 }}>
										Expertise
									</Box>

									<Box lineHeight={1.7} color="#515260">
										<p>
											Reading, language arts, social studies, science, and
											mathematics
										</p>
									</Box>
								</Box>
								<Box mb={6}>
									<Box mb={4} fontWeight={700} fontSize={{ xs: 20, sm: 30 }}>
										Education
									</Box>

									<Box lineHeight={1.7} color="#515260">
										<p>BFA and MA in Education</p>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>

			<Footer />
		</React.Fragment>
	);
};

export default AboutPerson;
export const loader = (route) =>
	loadable(() => import("./AboutPerson.component"), { ssr: !!route.ssr });
